import * as effects from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { api } from '@REST/api';
import { handleError } from '@bus/ui/saga/workers/handleError';
import { throwError } from '@bus/ui/saga/workers/throwError';

import { savedMessagesActions } from '../../actions';
import { FillMessagesSavedActionPayload, ISavedMessages } from '../../typedefs';

export function* fetchMessagesSaved({
  payload,
}: PayloadAction<FillMessagesSavedActionPayload>) {
  try {
    yield effects.put(savedMessagesActions.startFetching());
    const response: Response = yield effects.apply(api, api.get, [
      { endpoint: `saved-messages/projects/${payload.projectId}` },
    ]);
    if (!response.ok) {
      yield throwError(response);
    }
    const data: ISavedMessages = yield effects.call([response, 'json']);
    yield effects.put(
      savedMessagesActions.fillSavedMessages({
        data,
        projectId: payload.projectId,
      }),
    );
  } catch (e) {
    yield handleError(e);
  } finally {
    yield effects.put(savedMessagesActions.stopFetching());
  }
}
